var navItems = document.getElementsByClassName('nav-icon-top-safari');
var topCards = document.getElementsByClassName('top-card');

var next = document.getElementById('top-safaris-mobile-next');
var prev = document.getElementById('top-safaris-mobile-prev');
var numbers = document.getElementById('top-safaris-numbers');

var nextDesk = document.getElementById('top-safaris-desktop-next');
var prevDesk = document.getElementById('top-safaris-desktop-prev');

var topCardsLength = topCards.length;
var topCardsValNext;
var topCardsValPrev;

for (let i = 0; i < navItems.length; i++) {
    navItems[i].addEventListener('click', function() {
        doIT(i);
    });
};

for (let i = 0; i < topCards.length; i++) {
    topCards[i].addEventListener('click', function() {
        if (!topCards[i].classList.contains('active')) {
            let aTag = topCards[i].getElementsByTagName('a');
            event.preventDefault();
        }
    })
}

if (next) {
    next.addEventListener('click', function() {
        console.log('next clicked');
        for (let i = 0; i < topCards.length; i++) {
            if (topCards[i].classList.contains('active')) {
                var q;
                if (i == topCardsLength - 1) {
                    q = 0;
                } else {
                    q = i + 1;
                }
                console.log(q);
                doIT(q);
                break;
            }
        }
    })
    prev.addEventListener('click', function() {
        for (let i = 0; i < topCards.length; i++) {
            if (topCards[i].classList.contains('active')) {
                var q;
                if (i == 0) {
                    q = topCardsLength - 1;
                } else {
                    q = i - 1;
                }
                console.log(q);
                doIT(q);
                break;
            }
        }
    })

    nextDesk.addEventListener('click', function() {
        for (let i = 0; i < topCards.length; i++) {
            if (topCards[i].classList.contains('active')) {
                var q;
                if (i == topCardsLength - 1) {
                    q = 0;
                } else {
                    q = i + 1;
                }
                console.log(q);
                doIT(q);
                break;
            }
        }
    })
    prevDesk.addEventListener('click', function() {
        for (let i = 0; i < topCards.length; i++) {
            if (topCards[i].classList.contains('active')) {
                var q;
                if (i == 0) {
                    q = topCardsLength - 1;
                } else {
                    q = i - 1;
                }
                console.log(q);
                doIT(q);
                break;
            }
        }
    })
}

function doIT (i) {

    //Change Icons
    for (let ii = 0; ii < navItems.length; ii++) {
        navItems[ii].classList.remove('active');
    }
    navItems[i].classList.add('active');

    //Animate Out
    for (let iii = 0; iii < topCards.length; iii++) {
        if (topCards[iii].classList.contains('active') || topCards[iii].classList.contains('prev') || topCards[iii].classList.contains('next') ) {
            topCards[iii].classList.add('animateOut');
        }
    }

    if (i == 0) {
        topCardsValPrev = topCardsLength - 1;
    } else {
        topCardsValPrev = i - 1;
    }

    if ((topCardsLength - 1) == i) {
        topCardsValNext = 0;
    } else {
        topCardsValNext = i + 1;
    }

    setTimeout(function() {
        for (let iii = 0; iii < topCards.length; iii++) {
            topCards[iii].classList.remove('active');
            topCards[iii].classList.remove('animateOut');
            topCards[iii].classList.remove('animateIn');
            topCards[iii].classList.remove('prev');
            topCards[iii].classList.remove('next');
        }
        topCards[i].classList.add('active');
        topCards[i].classList.add('animateIn');

        topCards[topCardsValPrev].classList.add('prev');
        topCards[topCardsValPrev].classList.add('animateIn');

        topCards[topCardsValNext].classList.add('next');
        topCards[topCardsValNext].classList.add('animateIn');

        numbers.innerHTML = (i + 1) + ' / ' + (topCardsLength);
    }, 499)
}